import { EventSegmentType } from '@eti/schema-types';
import { duration as durationUtil } from '@eti/utils';
import type { BoundsType } from '../../../models';
import { transformSegments } from '../../../../order-details/components/overview/itinerary/drawer/utils/utils';
import { SegmentType } from '../../../../../constants/segmentTypesConstants';
import { SELF_TRANSFER } from '../../../../../constants/eventSegmentTypes';

export const hasLessThan2hSelfTransfer = (language: any, timeFormat: any, bounds: BoundsType) => {
  const segments = bounds?.flatMap((bound) => bound?.segments || []) || [];
  const selfTransferSegments = segments.filter(
    (segment) =>
      segment.__typename === 'EventSegment' &&
      segment.types?.includes(EventSegmentType.SelfTransfer),
  );

  const localizedDurations = selfTransferSegments.map((segment) =>
    durationUtil.getDuration(segment.duration ?? 0, language.code, timeFormat),
  );

  return localizedDurations.some((duration) => {
    const match = duration.match(/(\d+)\s*h/);
    const hours = match ? parseInt(match[1], 10) : 0;
    return hours < 2;
  });
};

export const tripHasSelfTransfer = (bounds: BoundsType) => {
  const segments = bounds?.flatMap((bound) => bound?.segments || []) || [];
  const hasSelfTransfer = segments.find(
    (segment) =>
      segment.__typename === 'EventSegment' &&
      segment.types?.includes(EventSegmentType.SelfTransfer),
  );
  return Boolean(hasSelfTransfer);
};

export const getSelfTransferPlaces = (bounds: BoundsType, segmentIndex: number) => {
  return transformSegments(bounds[segmentIndex].segments).reduce<string[]>((places, segment) => {
    if (
      segment.__typename === SegmentType.EVENT_SEGMENT &&
      segment.types?.includes(SELF_TRANSFER)
    ) {
      places.push(segment.previousDestination);
    }
    return places;
  }, []);
};
